<template>
  <div v-if="type === '0'" class="nameweb" id="movemain">
    <div class="div2" :style="`width:${moveW}px`">
      <span id="movename"
      class="spanname">{{name}}</span>
    </div>
  </div>
  <div v-else class="nameweball" id="movemain">
    <div class="div2" :style="`width:${moveW}px`">
      <span id="movename"
      class="spanname">{{name}}</span>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    name: {
      type: String,
      default: '--',
    },
    code: {
      type: String,
      default: '--',
    },
    type: {
      type: String,
      default: '0',
    },
  },
  created() {
  },
  mounted() {
    if (window.innerWidth <= 320) {
      this.moveW = 1;
    }
    if (window.innerWidth > 320 && window.innerWidth <= 375) {
      this.moveW = 1;
    } else {
      this.moveW = 1;
    }
    setTimeout(() => {
      this.configureMoveW();
    }, 2000);
  },
  data() {
    return {
      tabSelectIndex: 0,
      navH: 88,
      rcount: 100,
      moveW: 1,
    };
  },
  methods: {
    configureMoveW() {
      const movename = document.getElementById('movename');
      const movemain = document.getElementById('movemain');
      if (!movename) {
        this.moveW = 0;
        return;
      }
      const mv = movename.offsetWidth - movemain.offsetWidth;
      if (mv > 1) {
        console.log(movename.offsetWidth);
        console.log(movemain.offsetWidth);
        console.log(mv);
        this.moveW = mv;
      } else {
        this.moveW = 0;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.nameweball{
  height: 40px;
  width: 90%;
  flex: 1;
  display: flex;
  align-items: center;
  overflow:hidden;
  position:relative;
  white-space:nowrap;
  align-items: center;
  padding-top: 38px;
}
.namewebnoall{
  height: 40px;
  width: 83%;
  flex: 1;
  display: flex;
  align-items: center;
  overflow:hidden;
  position:relative;
  white-space:nowrap;
  align-items: center;
  padding-top: 38px;
}
.nameweb{
  height: 40px;
  width: 83%;
  flex: 1;
  display: flex;
  align-items: center;
  // overflow:hidden;
  position:relative;
  white-space:nowrap;
  align-items: center;
  padding-top: 38px;
}
.namewebno{
  height: 40px;
  width: 83%;
  flex: 1;
  display: flex;
  align-items: center;
  overflow:hidden;
  position:relative;
  white-space:nowrap;
  align-items: center;
  padding-top: 38px;
}
.mainback-jt{
  display: flex;
  position: absolute;
  left: 0;
  align-items: center;
  justify-content: center;
  white-space:nowrap;
}
.moveView{
  height: 40px;
}
.mainback{
  display: flex;
  position: absolute;
  left: 0;
  animation:myfirst 12s;
  // animation-iteration-count: infinite;
  align-items: center;
  justify-content: center;
  white-space:nowrap;
}
@keyframes myfirst
{
  0%   {left: 0;}
  25%  {left: -100%;}
  50%  {left: -100%;}
  75%  {left: 0;}
  100% {left: 0;}
}
.webtext{
  color: #000;
  font-size: 38px;
  white-space:nowrap;
  font-weight: bold;
}
.webtextbig{
  color: #000;
  font-size: 28px;
}
.webcodetext{
  color: #000;
  margin-left: 10px;
  font-size: 24px;
  font-family: DINAlternate-Bold;
}
.spancode{
  color: #000;
  margin-left: 10px;
  font-size: 24px;
  font-family: DINAlternate-Bold;
}
.spanname
{
position: absolute;
left: 0;
animation:myfirst2 12s;
animation-iteration-count: infinite;
color:#000;
  font-size: 38px;
  font-weight: bold;
}

.div2 {

  height: 40px;
display: inline-block;
position: relative;
color: #fff;
}

@keyframes myfirst2
{
0%   {left: 0;}
25%   {left: 0;}
50%  {left: -100%;}
75%  {left: -100%;}
100% {left: 0;}
}
</style>
